module.exports = __webpack_public_path__ + "static/img/bj.337147a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bj.png
// module id = 0U3x
// module chunks = 9